import { useMemo } from 'react';
import { Button } from 'components/Button';
import { StackProps } from 'components/Stack';
import theme from 'constants/theme';
import styled from 'styled-components';
import { UseFormWatch } from 'react-hook-form';
import { IChangeMessageLocalState } from './MainMessageComponent';

type Props = {
  isOnChange: boolean;
  watch: UseFormWatch<Partial<IChangeMessageLocalState>>;
  onClickCancelReservation: () => void;
  onClickModify: () => void;
  onClickCancel: () => void;
  onClickModifyComplete: () => void;
};
const MainMessageButtonDiv = ({
  isOnChange,
  watch,
  onClickCancelReservation,
  onClickModify,
  onClickCancel,
  onClickModifyComplete,
}: Props) => {
  const isDisabledButton = useMemo(() => {
    const validateRequest = watch();

    if (!!validateRequest) {
      if (validateRequest.title?.length === 0) {
        return true;
      }
      if (validateRequest.contents?.length === 0) {
        return true;
      }
      if (validateRequest?.recipent_infos && validateRequest.recipent_infos?.length === 0) {
        return true;
      }
      if (validateRequest?.date?.length === 0) {
        return true;
      }
      if (validateRequest?.messageId?.length === 0) {
        return true;
      }
      return false;
    } else {
      return true;
    }
  }, [watch()]);
  return (
    <ButtonDiv>
      <CancelButtonStyle
        type="button"
        variant="secondary"
        h={32}
        onClick={() => {
          if (isOnChange) {
            onClickCancel();
          } else {
            onClickCancelReservation();
          }
        }}
      >
        <ButtonText
          disable={true}
          style={{
            color: theme.colors.RG03,
            textAlign: 'center',
            fontSize: 16,
            fontWeight: 700,
          }}
        >
          {isOnChange ? '취소' : '예약 발송 취소'}
        </ButtonText>
      </CancelButtonStyle>

      <SaveButtonStyle
        type="button"
        variant="secondary"
        h={32}
        disabled={isOnChange && isDisabledButton}
        onClick={() => {
          if (isOnChange) {
            onClickModifyComplete();
          } else {
            onClickModify();
          }
        }}
      >
        <ButtonText disable={isOnChange && isDisabledButton}>{isOnChange ? '수정 완료' : '수정하기'}</ButtonText>
      </SaveButtonStyle>
    </ButtonDiv>
  );
};
export default MainMessageButtonDiv;

const ButtonDiv = styled.div<StackProps>`
  display: flex;
  padding: 20px;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  align-self: stretch;

  ${({ theme }) => ({
    borderRadius: `0px 0px 8px 8px`,
    borderTop: `1px solid ${theme.colors.RG06}`,
    background: '#fff',
  })}
`;

const CancelButtonStyle = styled(Button)`
  display: flex;
  width: 216px;
  height: 40px;
  padding: 8px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  ${({ theme }) => ({
    borderRadius: 8,
    border: `1px solid ${theme.colors.RG06}`,
    backgroundColor: theme.colors.RG00,
  })}
`;
const ButtonText = styled.text<ButtonTextProps>`
  ${({ theme, disable }) => ({
    color: `${disable ? theme.colors.RG04 : theme.colors.RG00}`,
  })}
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
  letter-spacing: -0.32px;
`;
type ButtonTextProps = {
  disable: boolean;
};
const SaveButtonStyle = styled(Button)`
  display: flex;
  width: 216px;
  height: 40px;
  padding: 8px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  ${({ theme, disabled }) => ({
    borderRadius: 8,
    backgroundColor: `${disabled ? theme.colors.RG07 : '#2E66F6'}`,
    borderColor: `${disabled ? theme.colors.RG07 : theme.colors.RG00}`,
  })}
`;
